import React, { useState } from 'react';
import { FiEye, FiEyeOff, FiPlus, FiTrash } from 'react-icons/fi';
import { TfiExport, TfiImport } from "react-icons/tfi";
import { ReportingTable } from '../../../Table/component/Table';

const ReportAnalytics = () => {
    const data = [{
        title: "Site 1 - Stationary Combustion",
        date: "2025-08-12",
        emission: "132"
    },
    {
        title: "Site 2 - Electric Vehicle",
        date: "2025-08-12",
        emission: "250"
    }]
    const [selectedRows, setSelectedRows] = useState(new Set())
    const column = [
        {
            header: 'Title',
            accessorKey: 'title',
            footer: 'Title',
        },
        {
            header: 'Date',
            accessorKey: 'date',
            footer: 'Date',
        },
        {
            header: 'Emission (Tonnes)',
            accessorKey: 'emission',
            footer: 'Emission',
        },
    ]
    const requestRowDeletion = () => {
        // setRowToDelete(rowId)
        // setShowDeleteModal(true)
    }
    const handleEditClick = () => {
        // setEditableData(rowData)
        // setModalMode('edit')
        // setShowContentModal(true)
    }
    return (
        <div className="flex flex-col p-4 w-full overflow-y-auto h-full">
            <div className="flex items-center md:flex-row justify-end items-center mb-4">
                <div className="flex space-x-2">
                    <button
                        // onClick={handleAddNewClick}
                        className="flex items-center justify-center bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-800 transition duration-300 w-40"
                        aria-label="Edit selected item"
                    >
                        <FiPlus className="mr-2" />
                        <span className="flex-1 text-center">Edit</span>
                    </button>
                    <button
                        // onClick={handleDeleteClick}
                        className="flex items-center justify-center bg-red-500 text-white py-2 px-4 rounded hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-800 transition duration-300 w-40"
                        aria-label="Delete selected items"
                    >
                        <FiTrash className="mr-2" />
                        <span className="flex-1 text-center">Delete</span>
                    </button>

                    <button
                        // onClick={handleDeleteClick}
                        className="flex items-center justify-center bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 dark:bg-green-600 dark:hover:bg-green-800 transition duration-300 w-40"
                        aria-label="Export selected items"
                    >
                        <TfiExport className="mr-2" />
                        <span className="flex-1 text-center">Export</span>
                    </button>

                    <button
                        // onClick={handleDeleteClick}
                        className="flex items-center justify-center bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-700 dark:bg-gray-600 dark:hover:bg-gray-800 transition duration-300 w-40"
                        aria-label="Import selected items"
                    >
                        <TfiImport className="mr-2" />
                        <span className="flex-1 text-center">Import</span>
                    </button>
                </div>
            </div>

            <div className="">
                <input
                    type="text"
                    placeholder="Search..."
                    //   value={searchTerm}
                    //   onChange={(e) => setSearchTerm(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                />
            </div>

            {/* {showContentModal && <MyModal onClose={() => setShowContentModal(false)} />} */}
            <ReportingTable
          data={data}
          columns={column}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          onRequestDelete={requestRowDeletion}
          onEdit={handleEditClick}
        />

        </div>
    );
};

export default ReportAnalytics;
